import { render, staticRenderFns } from "./certificateElementSettings.vue?vue&type=template&id=252cbbdb&scoped=true&"
import script from "./certificateElementSettings.vue?vue&type=script&lang=js&"
export * from "./certificateElementSettings.vue?vue&type=script&lang=js&"
import style0 from "./certificateElementSettings.vue?vue&type=style&index=0&id=252cbbdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252cbbdb",
  null
  
)

export default component.exports